import script from "./TrainModel.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainModel.vue?vue&type=script&setup=true&lang=js"

import "./TrainModel.vue?vue&type=style&index=0&id=e28bdb4c&lang=css"

const __exports__ = script;

export default __exports__